import { cx } from "@/utils/cx";
import type { CommunicationStatusTab, CommunicationTabCounts } from "../types";
import { getTabBadgeValue } from "../utils";

export type CommunicationStatusTabsProps = {
	activeTab: CommunicationStatusTab;
	counts: CommunicationTabCounts;
	isCountsLoading?: boolean;
	onTabChange: (tab: CommunicationStatusTab) => void;
};

type TabConfig = {
	id: CommunicationStatusTab;
	label: string;
	badgeClass: string;
	badgeTextClass: string;
	activeTextClass: string;
};

const TABS: TabConfig[] = [
	{
		id: "all",
		label: "Todos",
		badgeClass: "border-utility-blue-200 bg-utility-blue-50",
		badgeTextClass: "text-utility-blue-700",
		activeTextClass: "text-utility-blue-700",
	},
	{
		id: "connected",
		label: "Conectado",
		badgeClass: "border-utility-success-200 bg-utility-success-50",
		badgeTextClass: "text-utility-success-700",
		activeTextClass: "text-utility-success-700",
	},
	{
		id: "disconnected",
		label: "Desconectado",
		badgeClass: "border-utility-error-200 bg-utility-error-50",
		badgeTextClass: "text-utility-error-700",
		activeTextClass: "text-utility-error-700",
	},
];

export function CommunicationStatusTabs({
	activeTab,
	counts,
	isCountsLoading = false,
	onTabChange,
}: CommunicationStatusTabsProps) {
	return (
		<fieldset
			className="m-0 min-w-0 max-w-full border-secondary border-b border-solid p-0"
			data-slot="communication-status-tabs"
		>
			<legend className="sr-only">Filtrar por status de comunicação</legend>
			<div className="flex flex-wrap items-center gap-x-4 gap-y-3">
				{TABS.map((tab) => {
					const isActive = activeTab === tab.id;
					const badgeValue = getTabBadgeValue(tab.id, counts, isCountsLoading);

					return (
						<button
							aria-pressed={isActive}
							className={cx(
								"inline-flex h-9 cursor-pointer items-center gap-2 border-0 border-b-2 bg-transparent px-1 pb-3 font-semibold text-base transition-colors",
								"outline-focus-ring focus-visible:outline-2 focus-visible:outline-offset-2",
								isActive
									? cx("border-[#0080FE]", tab.activeTextClass)
									: "border-transparent text-tertiary"
							)}
							key={tab.id}
							onClick={() => {
								onTabChange(tab.id);
							}}
							type="button"
						>
							<span>{tab.label}</span>
							<span
								className={cx(
									"inline-flex min-w-[28px] items-center justify-center rounded-full border px-2.5 py-0.5 font-medium text-sm",
									tab.badgeClass,
									tab.badgeTextClass
								)}
							>
								{badgeValue}
							</span>
						</button>
					);
				})}
			</div>
		</fieldset>
	);
}
